import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Target, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import GoalRing from "@/components/reports/GoalRing";

export default function ReportsSummaryCard() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get("/reports/metrics").then((r) => setD(r.data)).catch(() => setErr(true));
  }, []);

  if (err) return null;

  const prog = d?.primary?.progress;
  const actions = d?.actions || [];
  const done = actions.filter((a) => a.done).length;

  return (
    <button data-testid="dashboard-goal-summary" onClick={() => navigate("/relatorios")}
      className="w-full text-left rounded-2xl border border-accent/25 bg-gradient-to-br from-accent/[0.07] via-card to-card p-4 sm:p-5 hover:border-accent/50 transition-colors flex items-center gap-4 sm:gap-6">
      {prog ? (
        <GoalRing pct={prog.pct} size={64} stroke={7} onTrack={prog.on_track}>
          <span className="text-sm font-extrabold text-foreground">{prog.pct}%</span>
        </GoalRing>
      ) : (
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-accent/10 text-accent"><Target className="h-6 w-6" /></span>
      )}
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground font-bold flex items-center gap-1.5"><Sparkles className="h-3 w-3 text-accent" />Sua meta de {d?.period?.label || "este mês"}</div>
        {prog ? (
          <>
            <div className="font-head text-base sm:text-lg font-bold text-foreground truncate mt-0.5">{d.primary.label}: {prog.current} / {prog.target}</div>
            <div className="mt-1.5 flex items-center gap-2">
              <div className="h-1.5 flex-1 max-w-[180px] rounded-full bg-white/8 overflow-hidden"><div className="h-full bg-gradient-to-r from-[#FFD24D] to-[#FFAA00]" style={{ width: `${Math.min(done / Math.max(actions.length, 1) * 100, 100)}%` }} /></div>
              <span className="text-xs text-muted-foreground shrink-0">Plano desta semana {done}/{actions.length || 3}</span>
            </div>
          </>
        ) : (
          <div className="font-head text-base sm:text-lg font-bold text-foreground mt-0.5">Defina sua meta e acompanhe seu ritmo</div>
        )}
      </div>
      <ArrowRight className="h-5 w-5 text-accent shrink-0" />
    </button>
  );
}
